import React, { useState } from 'react';
import styles from './renderHelpers.module.scss';

export function DescriptionItem({value, title, hint}) {

    const [showHint, setShowHint] = useState(false);

    let additional = '';
    if (title === 'Deployment price') additional = ` ${styles['description-detail__item--price']}`

    return (
        <div className={styles['description-detail__item-container']}>
            {
                showHint &&
                <div className={styles['description-detail__item-container__hint']}>
                    {hint}
                </div>
            }
            <div className={styles['description-detail__item'] + additional}>
                <div className={styles['description-detail__item__title']}>
                    <div className={styles['description-detail__item__title__text']}>
                        {title ? title : 'Undefined title'}:
                    </div>
                    {
                        !!hint &&
                        <i
                            className={`far fa-question-circle ${styles['description-detail__item__title__hint-trigger']}`}
                            onClick={() => setShowHint(!showHint)}
                            aria-hidden='true'
                        />
                    }
                </div>
                <div className={styles['description-detail__item__value']}>{value ? value : '—'}</div>
            </div>
        </div>
    )
}

export function formatDate(date) {
    // database time is written in ISO UTC (+0200), so ignore local user time
    // get UTC time in ISO format
    let currentDateISO = new Date().toISOString();
    // parse ISO format to javascript defaults by passing ISO time as argument
    let parsedCurrentTime = new Date(currentDateISO);
    // database time is already in ISO UTC, so just parse it
    let updateDate = new Date(date);
    // get time difference in milliseconds and then get days quantity from result
    let difference = (parsedCurrentTime.getTime() - updateDate.getTime()) / (1000 * 3600 * 24);
    difference = Math.ceil(difference);

    if (difference < 1) return 'less than day ago';
    else return `${difference} day(s) ago`;
}

export let AppsListOfType = props => {

    let appsList = [];
    let {app, type} = props;

    if (app && app[type] && !!app[type].length) appsList = app[type];

    return (
        <div className={styles['description-detail']}>
            {!!appsList?.length && appsList.map(app => {

                let source = app['static_stack_app_versions'] ? app['static_stack_app_versions'] : app['versions'];
                let versions = !!source?.length ? source.map(v => v['version']) : []; // get array of string versions
                versions = versions.join(', ');

                return <DescriptionItem value={versions} title={app.name} key={app.code}/>
            })}
        </div>
    )
};

export const Details = props => {

    let category = '', /*version,*/ lastUpdate, /*commercial,*/ source, github = '', ports, price;
    let {app} = props;

    if (app && !!Object.keys(app).length) {
        // price = app['commercial'] && app['price']['USD'] + ' $';
        const isFree = app.plan && !isNaN(parseFloat(app.plan)) && parseFloat(app.plan) === 1;
        const foundPrice = app.price?.find(p => p.currency === 'USD');
        price = isFree ? '$0' : '$ ' + foundPrice?.value;
        // version = app['version'] && app['version'];
        lastUpdate = app['_updated'] ? formatDate(app['_updated']) : (app['last_update'] && formatDate(app['last_update']));
        // commercial = app['commercial'] ? 'Yes' : 'No';
        ports = app['ports'] && app['ports'].replace(RegExp(/,/g), ", ");
        // prepare categories
        if (!!app['category'] && !!app['category'].length) {
            app['category'].map((cat, i) => {
                if (i === 0) category = cat;
                else category += ', ' + cat
            })
        }
        // prepare github link
        let foundGithubLink = app['github'] && app['github'].find(link => link['type'] === 'github');
        if (foundGithubLink) {
            github = (
                <a href={foundGithubLink['url']} target="_blank" rel={!foundGithubLink.follow ? 'nofollow' : undefined}>
                    {foundGithubLink['title'] ? foundGithubLink['title'] : 'Github'}
                    <i className="fas fa-external-link-alt" aria-hidden="true"/>
                </a>
            )
        }
        // prepare usual link
        let foundSourceLink = app['links'] && app['links'].find(link => link['type'] === 'vendor');
        if (foundSourceLink) {
            source = (
                <a href={foundSourceLink['url']} target="_blank" rel={!foundSourceLink.follow ? 'nofollow' : undefined}>
                    {foundSourceLink['title'] ? foundSourceLink['title'] : 'Link'}
                    <i className="fas fa-external-link-alt" aria-hidden="true"/>
                </a>
            )
        }
    }

    return (
        <div className={styles['description-detail']}>
            <DescriptionItem
                value={price}
                title='Deployment price'
                hint={`The price we quote pertains exclusively to the deployment service. It incorporates the expenses incurred in utilizing the cloud provider's infrastructure as well as the time and effort expended by our developers in pre and post configuration of the application stack.`}
            />
            <DescriptionItem value={category} title='Category'/>
            <DescriptionItem value={ports} title='Public Ports'/>
            <DescriptionItem value={source} title={`Vendor's page`}/>
            <DescriptionItem value={github} title='Source code'/>
            <DescriptionItem value={lastUpdate} title='Last Update'/>
        </div>
    )
};

export const SystemRequirements = props => {
    let diskSize, ramSize;
    let {app} = props;

    if (app && !!Object.keys(app).length) {
        diskSize = parseFloat(app['disk_size']) && parseFloat(app['disk_size']) + ' Gb';
        ramSize = parseFloat(app['ram_size']) && parseFloat(app['ram_size']) + ' Gb';
    }

    return (
        <div className={styles['description-detail']}>
            <DescriptionItem value={diskSize} title='Disk Size'/>
            <DescriptionItem value={ramSize} title='RAM Size'/>
        </div>
    )
};